import Box from "@mui/material/Box";
import type { ComponentProps } from "react";

export const VisuallyHiddenInput = (props: ComponentProps<"input">) => (
  <Box
    component="input"
    sx={{
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      overflow: "hidden",
      position: "absolute",
      bottom: 0,
      left: 0,
      whiteSpace: "nowrap",
      width: "1px",
    }}
    {...props}
  />
);
